// src/api/constants/notifications/notificationLevelColors.ts

/**
 * 🎨 Colores oficiales por nivel de notificación
 *
 * Debe mantenerse 1:1 con backend:
 * com.base.starter.codenovapos.enums.NotificationLevel
 *
 * Uso:
 * - iconos
 * - badges
 * - bordes
 * - estados visuales
 * - modales
 * - alertas
 *
 * Referencia backend:
 * NotificationLevel.java
 * NotificationLevelResolver.java
 */
export const NOTIFICATION_LEVEL_COLORS: Record<
  string,
  string
> = {
  // =========================================================
  // 🟦 NIVELES BASE
  // =========================================================

  INFO: "#3BA2B8", // azul info
  SUCCESS: "#3CA745", // verde éxito
  WARNING: "#F9C107", // amarillo advertencia
  ERROR: "#DC3545", // rojo error
  CRITICAL: "#DC3545", // rojo fuerte

  // =========================================================
  // 🟨 FUNCIONALES
  // =========================================================

  AUDIT: "#637381", // gris auditoría
  SECURITY: "#F9C107", // amarillo seguridad
  FINANCIAL: "#13C296", // verde financiero
  STOCK: "#F9C107", // warning inventario
  SALE: "#3BA2B8", // azul ventas
  PURCHASE: "#3CA745", // verde compras
  INVENTORY: "#3BA2B8", // azul inventario

  // =========================================================
  // 🟩 INTEGRACIONES
  // =========================================================

  INTEGRATION: "#13C296",
  SYNC: "#3BA2B8",
  API: "#3BA2B8",
  NETWORK: "#F9C107",

  // =========================================================
  // 🟪 SOPORTE / MANTENIMIENTO
  // =========================================================

  SUPPORT: "#3BA2B8",
  MAINTENANCE: "#13C296",
  SYSTEM_UPDATE: "#3BA2B8",
  BACKUP: "#637381",
  PERFORMANCE: "#F9C107",

  // =========================================================
  // ⚫ USUARIO / PERSONALIZACIÓN
  // =========================================================

  USER_ACTIVITY: "#3CA745",
  USER_FEEDBACK: "#3BA2B8",
  ANNOUNCEMENT: "#3BA2B8",
  TRAINING: "#13C296",

  // =========================================================
  // 🟥 SISTEMA AVANZADO
  // =========================================================

  DATABASE: "#DC3545",
  SERVICE: "#3BA2B8",
  SCHEDULER: "#F9C107",
  HARDWARE: "#212B36",
  PRINTER: "#F9C107",
  DEVICE: "#3BA2B8",
  CLOUD: "#3BA2B8",
  ALERT: "#F9C107",
  UNKNOWN: "#637381",
};